export const PHOTOS_ARE_LOADING = 'PHOTOS_ARE_LOADING'
export const PHOTOS_LOADED = 'PHOTOS_LOADED'
export const PHOTOS_FAILED = 'PHOTOS_FAILED'
export const PHOTOS_CHANGE_FILTER = 'PHOTOS_CHANGE_FILTER'

export const SELECT_PHOTO_SIDEBAR = 'SELECT_PHOTO_SIDEBAR'
export const DESELECT_PHOTO_SIDEBAR = 'DESELECT_PHOTO_SIDEBAR'
export const REMOVE_PHOTO_SIDEBAR = 'REMOVE_PHOTO_SIDEBAR'



// WEBPACK FOOTER //
// ./src/constants/photosActions.js